<template>
  <div class="contentBar">
    <div class="titleReport flex-wrap flex-vc">
      <!--<div class="blueIcon"></div>-->
      <div class="titleName">{{ titleName }}</div>
    </div>
    <div class="barList">
      <div v-for="sc in dataBar" :key="sc.name" class="colorBar" :style="{width:$options.filters.widthPercent(sc.count,totalNum),background:sc.color}"></div>
    </div>
    <div class="barExplain">
      <div v-for="sc in dataBar" :key="sc.name" class="explainBar">
        <div class="smallPart" :style="{background:sc.color}"></div>
        <div class="name">{{sc.category_name}}</div>
        <div class="num">{{sc.count}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'barComponent',
  props: {
    dataBar: {
      type: Array,
      default: function () {
        return []
      }
    },
    titleName: ''
  },
  computed: {
    totalNum () {
      let total = 0
      this.dataBar.forEach(function (v) {
        total += v.count
      })
      return total
    }
  },
  filters: {
    widthPercent (width, total) {
      return width / total * 100 + '%'
    }
  },
  watch: {
    dataBar: function (newVal, oldVal) {
      this.dataBar = newVal
    }
  }
}
</script>
<style lang="stylus" scoped>
  .contentBar{
    padding 0 0.5rem
    .titleReport{
      background $white
      margin-bottom 1rem
      .blueIcon{
        margin 0 1rem 0 0.625rem
        width 0.625rem
        height @width
        border-radius (@width/2)
        background $blue
      }
      .titleName{
        color $pepperGrey
        font-size 1rem
      }
    }
    .colorBar{
      display inline-block
      height 2.75rem
    }
    .barList{
      height 2.75rem
      margin-bottom 1rem
    }
    .barExplain{
      text-align left
      .explainBar{
        display: inline-block
        margin-right 0.5rem
        font-size 0.875rem
        div{
          display: inline-block
        }
        .smallPart{
          width 0.8rem
          height @width
          border-radius (@width/2)
        }
        .name{
          color $pepperGrey
        }
        .num{
          color $pepperGrey
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pagesPc/others/barComponent.vue